export class ComparaisonHelper {
    /**
     * Compare 2 valeurs à trier
     * @param a : valeur 1
     * @param b : valeur 2
     * @param isAsc : Valeur indiquant si le tri est ascendant (true) ou descendant (false).
     * @returns : retourne -1 si A est inférieur à B, 1 si A est supérieur à B, 0 si A est égal à B dans le cas d'un tri ascendant ou 1 si A est inférieur à B, -1 si A est supérieur à B, 0 si A est égal à B dans le cas d'un tri descendant.
     */
    public static compare(a: number | string | Date, b: number | string | Date, isAsc: boolean): number {
        if (!a) {
            return -1 * (isAsc ? 1 : -1);
        } else if (!b) {
            return 1 * (isAsc ? 1 : -1);
        }

        if (typeof a === 'string' && typeof b === 'string') {
            if (isAsc === true) {
                return (a as string).localeCompare(b as string, 'fr-FR', {
                    sensitivity: 'base',
                });
            } else {
                return (b as string).localeCompare(a as string, 'fr-FR', {
                    sensitivity: 'base',
                });
            }
        } else {
            return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
        }
    }
}
